import React, { Component } from 'react';
import { connect } from 'react-redux';
import { path, find, propEq } from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import {
  getHistory,
  fetchEmployee,
  format_ss_no
} from '../../api/employees';
import Preloader from "../../common/Preloader";

export class EmployeeLogs extends Component {

  constructor(props) {
    super(props);
    this.build = this.build.bind(this);
  }

  state = {
    loading: true
  };

  componentDidUpdate() {
    const history = path(['employees', 'employeeHistory'], this.props);
    const { loading } = this.state;
    if ( loading && history ) {
      this.setState({ loading: false });
    }
  }
  componentWillMount() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.employeeHistory(id);
    this.props.getDataById(id);
  }

  build() {
    const arrResult = [];
    const history = path(['employees', 'employeeHistory'], this.props) || null;

    if (history) {
      //let parsed = JSON.parse(history);
      let parsed = history;
      if (parsed && parsed.data) {
        for (let i = 0; i < parsed.data.length; i++) {
          arrResult.push(
            <div key={i} dangerouslySetInnerHTML={{ __html: parsed.data[i].html }}></div>
          );
        }
      }
    }

    return arrResult;
  }

  render() {
    const id = path(['match', 'params', 'id'], this.props);

    const employee = path(['employees', 'currentEmployee'], this.props);
    let lbl = 'Employee';

    if (employee) {
        // lbl = `Employee #${format_ss_no(employee.ss_no)} (${employee.firstname} ${employee.lastname})`;
        lbl = `${employee.firstname} ${employee.lastname}`;
    }

    const {loading} = this.state;
    const mainPart = loading ? <Preloader show={true} type='circle'/> : this.build();
    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
         { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
         { url: '/pages/employees', icon: 'people', name: 'Employees' },
         { url: '/pages/employee/' + id, icon: 'account_circle', name: lbl },
         { icon: 'mode_comment', name: 'Logs' },
        ]} />
        <div>{mainPart}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDataById: (id) => {
      fetchEmployee(id)(dispatch);
    },
    employeeHistory: (id) => {
      getHistory(id)(dispatch);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeLogs);



// WEBPACK FOOTER //
// ./src/containers/EmployeeLogs/index.js